import { useCallback, useEffect, useMemo, useState } from "react";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { useLocation } from "react-router-dom";
import { useGetBrandStepList } from "./BrandCampaignStep/useBrandCampaignStep";
import { FaEdit } from "react-icons/fa";
import BrandCampaignStepModal from "./BrandCampaignStep/BrandCampaignStepModal";
import { Btn } from "../../AbstractElements";
import { showToast } from "../../utils/toastUtils";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { COLORS } from "../../constants/colors";

const brandCampaignStep = (
  handleEdit: (row: any, status: string) => void,
  isLocked: boolean,
  status: string
) => [
  {
    name: "Agenda Type",
    selector: (row: any) => row.AgendaType || "-",
    sortable: true,
    maxWidth: "40%",
    wrap: true,
  },
  {
    name: "Name",
    selector: (row: any) => row.Name || "-",
    sortable: true,
    maxWidth: "40%",
    wrap: true,
  },
  {
    name: "Level",
    selector: (row: any) => row.Level || "-",
    sortable: true,
    maxWidth: "40%",
    wrap: true,
  },
  {
    name: "Moye",
    selector: (row: any) => row.Moye || "-",
    sortable: true,
    maxWidth: "40%",
    wrap: true,
  },
  {
    name: "Action",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <Btn
          className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
          // style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
          onClick={() => handleEdit(row, "update")}
          disabled={status === "Published" || status === "Started" || isLocked}
          style={{
            backgroundColor:
              status === "Published" || status === "Started" || isLocked
                ? "grey"
                : "#43bab2",
            borderRadius: "20px",
            padding: "3px",
            width: "70px",
            color: "white",
            borderColor: "none",
          }}
        >
          <FaEdit size={14} style={{ fill: "#fff" }} />
          Edit
        </Btn>
      </div>
    ),
  },
];

const BrandCampaignStep = () => {
  const { startPolling, stopPolling } = useExcelPolling();
  const location = useLocation();
  const { rowData } = location.state;
  const isLocked = useMemo(() => {
    if (!rowData?.LockingDate) return false;

    const lockDate = new Date(rowData.LockingDate);
    const today = new Date();

    lockDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return lockDate <= today;
  }, [rowData?.LockingDate]);

  const [filtersState, setFiltersState] = useState<any>({
    start: 1,
    lenght: 10,
    search: "",
  });

  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");

  const [isModal, IsSetModal] = useState(false);
  const [mode, setMode] = useState("");
  const [BrandCampiagnVisitPlanId, setBrandCampiagnVisitPlanId] = useState();
  const [BrandCampiagnId, SetBrandCampiagnId] = useState(
    rowData.BrandCampiagnId
  );
  const [BrandCampiagnRowData, setBrandCampiagnRowData] = useState();
  const [BrandCampiagnStartDate, setBrandCampiagnStartDate] = useState("");
  const [BrandCampiagnEndDate, setBrandCampiagnEndDate] = useState("");

  useEffect(() => {
    if (rowData?.CreatedAt) {
      setBrandCampiagnStartDate(rowData?.StartDate);
      setBrandCampiagnEndDate(rowData?.EndDate);
    }
  }, [rowData]);

  const { data, isLoading, isSuccess } = useGetBrandStepList({
    enable: true,
    params: {
      start: filtersState.start,
      length: filtersState.lenght,
      search: filtersState.search,
    },
    id: rowData.BrandCampiagnId,
  });

  const toggleModal = () => {
    IsSetModal(!isModal);
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
        length: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleEdit = (row: any) => {
    setBrandCampiagnRowData(row);
    setMode("edit");
    setBrandCampiagnVisitPlanId(row.BrandCampiagnVisitPlanId);
    IsSetModal(true);
  };
  const handleAddAgenda = () => {
    setMode("add");
    IsSetModal(true);
  };

  const onCloseModal = useCallback(() => IsSetModal(false), []);

  const downloadExcelGet = async () => {
    const id: number = rowData?.BrandCampiagnId;

    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.BRAND_CAMPAIGN.GET_BRAND_CAMPIAGN_STEP_EXCEL}/${id}`
      );
      const { success, fileDownloadId, intervalTime } = response?.data?.data || null;

      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFailed: (msg: any) => {
            showToast.error(msg || "onFailed in Brandcampaign step");
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "OnExpire in Brandcampaign step");
            stopPolling();
            setLoadingExcel(false);
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "onDelete in Brandcampaign step");
            stopPolling();
            setLoadingExcel(false);
          },
        });
      }
    } catch (err: any) {
      showToast.error(err);
    }
  };
  return (
    <>
      <div className="p-2">
        <PageHeader
          title={`Brand Campaign Steps | ${rowData?.CampiagnName}`}
          buttons={[
            {
              label: loadingExcel
                ? excelStatus
                  ? excelStatus.charAt(0).toUpperCase() +
                    excelStatus.slice(1) +
                    ".."
                  : ""
                : "Excel",
              onClick: () => downloadExcelGet(),
              color: loadingExcel ? COLORS.disable : COLORS.primary,
              disable: loadingExcel ? true : false,
            },
            {
              label: "+ Add Steps",
              onClick: () => handleAddAgenda(),
              // color: "#2e8dd3",
              disable:
                rowData?.Status === "Published" ||
                rowData?.Status === "Started" ||
                isLocked
                  ? true
                  : false,
              textColor: "white",
              color:
                rowData?.Status === "Published" ||
                rowData?.Status === "Started" ||
                isLocked
                  ? "grey"
                  : "#43B9B2",
            },
          ]}
        />

        <BasicDataTable
          Title="Brand Campaign Steps"
          data={(!isLoading && isSuccess && data.data) || []}
          dynamicHeightOnRowsPerPage={true}
          columns={brandCampaignStep(handleEdit, isLocked, rowData.Status)}
          showSpinner={isLoading}
          onChangePage={(pageNo: number) => {
            handlePagination(pageNo);
          }}
          onChangeRowsPerPage={(newPerPage: any, page: any) => {
            handleonChangeRowsPerPage(newPerPage, page);
          }}
          handleSearch={(val: any) => {
            handleSearch(val);
          }}
          paginationTotalRows={data?.rowData.data?.recordsTotal || 0}
        />

        {(rowData.Status === "Published" || rowData.Status === "Draft") &&
        mode == "add" ? (
          <RouteModal
            isOpen={isModal}
            toggle={toggleModal}
            title="Add Agenda"
            size="md"
            content={
              <BrandCampaignStepModal
                mode={mode}
                BrandCampiagnId={BrandCampiagnId}
                BrandCampiagnVisitPlanId={BrandCampiagnVisitPlanId}
                onClose={onCloseModal}
                OrgIDFromBrandCampagin={rowData.OrgUnitId}
                BrandCampiagnStartDate={BrandCampiagnStartDate}
                BrandCampiagnEndDate={BrandCampiagnEndDate}
              />
            }
          />
        ) : mode === "edit" ? (
          <RouteModal
            isOpen={isModal}
            toggle={toggleModal}
            title="Edit Step"
            size="md"
            content={
              <BrandCampaignStepModal
                mode={mode}
                BrandCampiagnId={BrandCampiagnId}
                BrandCampiagnVisitPlanId={BrandCampiagnVisitPlanId}
                onClose={onCloseModal}
                OrgIDFromBrandCampagin={rowData.OrgUnitId}
                BrandCampiagnRowData={BrandCampiagnRowData}
                BrandCampiagnStartDate={BrandCampiagnStartDate}
                BrandCampiagnEndDate={BrandCampiagnEndDate}
              />
            }
          />
        ) : null}
      </div>
    </>
  );
};

export default BrandCampaignStep;
